<div [ngClass]="alertClasses" class="d-flex align-items-center " role="alert">
  <div class="flex-fill">{{ message() }}</div>

  @if(dismissable()){
  <button
    type="button"
    class="btn-close"
    data-dismiss="alert"
    aria-label="Cerrar"
    (click)="onDismiss()"
  >
  </button>
  }
</div>
